import { ReactElement } from 'react';
import { BetslipGlobalStateProvider } from 'newelements/_Betslip/providers/BetslipGlobalStateProvider';
import { BetslipConfigsContextProvider } from 'newelements/_Betslip/providers/configs-provider';

export const BetslipRootProvider = ({
  children
}: PropsWithChildren): ReactElement => {
  return (
    <BetslipConfigsContextProvider>
      <BetslipGlobalStateProvider>{children}</BetslipGlobalStateProvider>
    </BetslipConfigsContextProvider>
  );
};
